'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId } from '@morpho-org/blue-sdk';
import type { Time } from '@morpho-org/morpho-ts';
import type { OptionSelect } from '@morpho-org/ui-v6/client';
import { type ReactNode, useState } from 'react';
import { formatTimeseriesData, removeNullYValuesFromSeries } from '@/components/charts/helpers/highcharts';
import { CardDashboard } from '@/components/common/Card/CardDashboard';
import { type BorrowDashboardMode, useDashboardContext } from '@/contexts/Dashboard/Dashboard.context';
import { useViewedAccountAddress } from '@/hooks/useViewedAccountAddress';
import { useFeatureFlags } from '@/lib/shared/components/FeatureFlagsProvider';
import { useDashboardMarketHistory } from '../hooks/useDashboardUserHistory';
import DashboardBorrowHeroTotalBorrow from './DashboardBorrowHeroTotalBorrow';
const modeOptions: OptionSelect<BorrowDashboardMode>[] = [{
  label: 'Loans',
  value: 'loan'
}, {
  label: 'Collateral',
  value: 'collateral'
}];
interface DashboardBorrowHeroBorrowChartProps {
  chainIds: ChainId[];
  titleExtra: ReactNode;
}
const DashboardBorrowHeroBorrowChart = t0 => {
  const $ = _c(27);
  const {
    chainIds,
    titleExtra
  } = t0;
  const {
    address
  } = useViewedAccountAddress();
  const {
    isDashboardExpanded,
    isDashboardHovered,
    isSmallDashboard,
    borrowDashboardMode,
    setBorrowDashboardMode
  } = useDashboardContext();
  const {
    positionHistory: isPositionHistoryEnabled
  } = useFeatureFlags();
  const [timeFrame, setTimeFrame] = useState("w");
  let t1;
  if ($[0] !== address || $[1] !== borrowDashboardMode || $[2] !== chainIds || $[3] !== isPositionHistoryEnabled || $[4] !== timeFrame) {
    t1 = {
      address,
      chainIds,
      timeFrame,
      type: borrowDashboardMode,
      enabled: isPositionHistoryEnabled
    };
    $[0] = address;
    $[1] = borrowDashboardMode;
    $[2] = chainIds;
    $[3] = isPositionHistoryEnabled;
    $[4] = timeFrame;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const {
    points,
    loading,
    isError
  } = useDashboardMarketHistory(t1);
  let t2;
  if ($[6] !== points) {
    t2 = removeNullYValuesFromSeries(formatTimeseriesData(points));
    $[6] = points;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const chartData = t2;
  const isFilterDisabled = !isPositionHistoryEnabled || loading;
  let t3;
  if ($[8] !== chainIds) {
    t3 = <DashboardBorrowHeroTotalBorrow chainIds={chainIds} />;
    $[8] = chainIds;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== setBorrowDashboardMode) {
    t4 = mode => {
      setBorrowDashboardMode(mode as BorrowDashboardMode);
    };
    $[10] = setBorrowDashboardMode;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== borrowDashboardMode || $[13] !== chartData || $[14] !== isDashboardExpanded || $[15] !== isDashboardHovered || $[16] !== isError || $[17] !== isSmallDashboard || $[18] !== loading || $[19] !== t4 || $[20] !== timeFrame) {
    t5 = {
      isExpanded: isDashboardExpanded,
      isHovered: isDashboardHovered,
      isSmall: isSmallDashboard,
      isLoading: loading,
      data: chartData,
      error: isError,
      timeFrame,
      mode: borrowDashboardMode,
      modeOptions,
      modeLabel: "Position",
      setTimeFrame,
      setMode: t4
    };
    $[12] = borrowDashboardMode;
    $[13] = chartData;
    $[14] = isDashboardExpanded;
    $[15] = isDashboardHovered;
    $[16] = isError;
    $[17] = isSmallDashboard;
    $[18] = loading;
    $[19] = t4;
    $[20] = timeFrame;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== isFilterDisabled || $[23] !== t3 || $[24] !== t5 || $[25] !== titleExtra) {
    t6 = <CardDashboard testId="dashboard-borrow-chart" title="" titleExtra={titleExtra} hideSizeButton={true} totalSlot={t3} isFilterDisabled={isFilterDisabled} state={t5} />;
    $[22] = isFilterDisabled;
    $[23] = t3;
    $[24] = t5;
    $[25] = titleExtra;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  return t6;
};
export default DashboardBorrowHeroBorrowChart;